module.exports = __webpack_public_path__ + "fe87328bee93dbdc0fad009248b7e11f.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/2011_teaser_image.jpg
// module id = 558
// module chunks = 0